import { render, staticRenderFns } from "./mamSubRightBar.vue?vue&type=template&id=83b035ce&scoped=true"
import script from "./mamSubRightBar.vue?vue&type=script&lang=js"
export * from "./mamSubRightBar.vue?vue&type=script&lang=js"
import style0 from "./mamSubRightBar.vue?vue&type=style&index=0&id=83b035ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b035ce",
  null
  
)

export default component.exports